import { ADMIN_PERMISSIONS, SYSTEM_PERMISSION } from '../../constants';
import { checkPermission } from '../../Utilities/appHelpers';

export interface sidebarItem {
   route: string;
   text: string;
   icon: string;
   show?: boolean;
}

//Data for the sideBar
export const MENUITEMS = () => [
   {
      text: 'Dashboard',
      route: '/dashboard',
      icon: 'ri-dashboard-fill',
      show: true,
   },
   {
      text: 'Patients',
      route: '/patient',
      icon: 'ri-user-3-fill',
      show: checkPermission(SYSTEM_PERMISSION.API_PDM_OP_GET_PATIENT_LIST),
   },
   {
      text: 'Orders',
      route: '/orders',
      icon: 'ri-capsule-fill',
      show: checkPermission(
         [
            SYSTEM_PERMISSION.API_ERX_REFILL_REQUEST_LIST,
            SYSTEM_PERMISSION.API_ERX_CHANGE_REQUEST_LIST,
            SYSTEM_PERMISSION.API_PCO_GET_RX_ORDER_LIST,
         ],
         false,
      ),
      items: [
         {
            text: 'Incoming Refill Request',
            route: '/orders/incoming-refill-requests',
            show: checkPermission(SYSTEM_PERMISSION.API_ERX_REFILL_REQUEST_LIST),
            // icon: 'ri-refresh-line',
         },
         {
            text: 'Change Request',
            route: '/orders/change-requests',
            show: checkPermission(SYSTEM_PERMISSION.API_ERX_CHANGE_REQUEST_LIST),
            // icon: 'ri-arrow-up-down-line',
         },
         {
            text: 'Outgoing Precription Orders',
            route: '/orders/outgoing-prescription-orders',
            show: checkPermission(SYSTEM_PERMISSION.API_PCO_GET_RX_ORDER_LIST),
         },
      ],
   },
   {
      text: 'Practice Admin',
      route: '/practiceAdmin',
      icon: 'ri-admin-fill',
      show: checkPermission(ADMIN_PERMISSIONS, true),
      items: [
         {
            text: 'User Management',
            route: '/users',
            show: true,
            // icon: 'ri-add-circle-fill',
         },
         {
            text: 'Group Management',
            route: '/groups',
            show: true,
            // icon: 'ri-add-circle-fill',
         },
         {
            text: 'Role Management',
            route: '/roles',
            show: true,
            // icon: 'ri-add-circle-fill',
         },
         {
            text: 'Practice Manager',
            route: '/practiceManager',
            show: true,
            // icon: 'ri-add-circle-fill',
         },
         {
            text: 'Security Audit Reports',
            route: '/security-audit-reports',
            show: true,
            // icon: 'ri-add-circle-fill',
         },
      ],
   },
   {
      text: 'Activity Reports',
      route: '/activity-log-reports',
      icon: 'ri-settings-fill',
      show: checkPermission(SYSTEM_PERMISSION.API_UGRP_LOAD_LOGGED_ACTIVITY),
   },
];
